import tippy, {hideAll} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './styles.scss';

const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn({hide}) {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        hide();
      }
    }

    return {
      onShow(e) {
        e.reference.setAttribute('aria-expanded', true);
        document.addEventListener('keydown', onKeyDown);
      },
      onHide(e) {
        e.reference.setAttribute('aria-expanded', false);
        document.removeEventListener('keydown', onKeyDown);
      },
    };
  },
};

class SMDropdown {
  // @param {(String|Element|Element[]|NodeList)} element
  // @param {Object} options
  // More info https://atomiks.github.io/tippyjs/
  static init(element, options) {
    const defaults = {
      trigger: 'click',
      placement: 'bottom',
      arrow: false,
      allowHTML: true,
      theme: element.dataset.theme ? element.dataset.theme : 'dropdown',
      interactive: true,
      plugins: [hideOnEsc],
      onShown: () => {
        document.dispatchEvent(new CustomEvent('sm-dropdown:shown', { detail: { container: document.querySelector('[data-tippy-root]') } }));
        if (options.onShown && typeof options.onShown === 'function') {
          options.onShown();
        }
      },
      appendTo: () => document.body
    };
    if (!element._tippy) {
      return tippy(element, {...defaults, ...options} );
    }
  }

  static closeAll() {
    hideAll();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-sm-dropdown').forEach(d => {
    SMDropdown.init(d, {
      content: d.parentNode.querySelector('.js-dropdown-content').innerHTML
    });
  });

  document.addEventListener('html-updated', (e) => {
    const wrap = e.detail && e.detail.container ? e.detail.container : 'body';
    document.querySelectorAll(`${wrap} .js-sm-dropdown`).forEach(d => {
      SMDropdown.init(d, {
        content: d.parentNode.querySelector('.js-dropdown-content').innerHTML
      });
    });
  });
});

export default SMDropdown;
